export default __webpack_public_path__ + "static/media/4_3.636a0034.jpg";